import React from "react";
import { Link } from "react-router-dom";
import { Sun, Mail, Phone, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-navy-900 text-white relative overflow-hidden" data-testid="main-footer">
      <div className="absolute -top-32 -left-20 blob-pink opacity-30" />
      <div className="absolute -bottom-32 -right-20 blob-pink opacity-20" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 rounded-full gradient-pink flex items-center justify-center">
                <Sun className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <span className="font-heading font-black text-xl">Helios Bright</span>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="font-heading font-bold mb-4 text-brand text-sm uppercase tracking-widest">{t.footer.services}</h4>
            <ul className="space-y-3 text-slate-300 text-sm">
              <li><Link to="/thuisbatterijen" className="hover:text-brand transition-colors">Thuisbatterijen</Link></li>
              <li><Link to="/aeg-plug-play" className="hover:text-brand transition-colors">AEG Plug & Play</Link></li>
              <li><Link to="/zonnepanelen" className="hover:text-brand transition-colors">Zonnepanelen</Link></li>
              <li><Link to="/laadpalen" className="hover:text-brand transition-colors">Laadpalen</Link></li>
              <li><Link to="/zakelijk" className="hover:text-brand transition-colors">Zakelijke Oplossing</Link></li>
              <li><Link to="/duurzaam-financieren" className="hover:text-brand transition-colors">Duurzaam Financieren</Link></li>
              <li><Link to="/werking" className="hover:text-brand transition-colors">Werking</Link></li>
              <li><Link to="/installatie" className="hover:text-brand transition-colors">Installatie</Link></li>
              <li><Link to="/merken" className="hover:text-brand transition-colors">Merken</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold mb-4 text-brand text-sm uppercase tracking-widest">{t.footer.company}</h4>
            <ul className="space-y-3 text-slate-300 text-sm">
              <li><Link to="/over-ons" className="hover:text-brand transition-colors">{t.nav.about}</Link></li>
              <li><Link to="/reviews" className="hover:text-brand transition-colors">{t.nav.reviews}</Link></li>
              <li><Link to="/faq" className="hover:text-brand transition-colors">{t.nav.faq}</Link></li>
              <li><Link to="/contact" className="hover:text-brand transition-colors">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold mb-4 text-brand text-sm uppercase tracking-widest">{t.nav.contact}</h4>
            <ul className="space-y-3 text-slate-300 text-sm">
              <li className="flex items-center gap-2"><Phone size={16} className="text-brand" /> <a href="tel:+31852502086" className="hover:text-brand transition-colors" data-testid="footer-phone">+31 85 250 2086</a></li>
              <li className="flex items-center gap-2"><Mail size={16} className="text-brand" /> <a href="mailto:info@heliosbright.nl" className="hover:text-brand transition-colors">info@heliosbright.nl</a></li>
              <li className="flex items-center gap-2"><MapPin size={16} className="text-brand" /> Hereplein 4, 9711 GA Groningen</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-7 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-slate-400">
          <p>{t.footer.copyright}</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-brand transition-colors">Privacy</a>
            <a href="#" className="hover:text-brand transition-colors">Algemene voorwaarden</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
